import { createTheme, Theme } from '@mui/material';

import palette from './palette';
import breakpoints from './breakpoints';
import typography from './typography';

import components from './components';

const primaryTheme: Theme = createTheme({
  breakpoints,
  palette,
  typography,
  components
});

export default primaryTheme;
